import { Box } from 'dash-ui';
import styled from 'styled-components';

export const TabsWrapper = styled(Box)<{ isFolder?: boolean }>`
  border-radius: ${({ theme }) => theme.space + 2}px;
  border: 1px solid ${({ theme }) => theme.colors.n50};

  & > div:nth-child(${({ isFolder }) => (isFolder ? 2 : 1)}) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.n50};
  }
`;
